import { createSlice } from '@reduxjs/toolkit';

interface LoginData {
  success?: boolean;
  token?: string;
  data?: {
    role?: string;
  };
  message?: string;
}

interface AuthState {
  DeviceToken: string;
  globalError: any;
  customerCallModal: boolean;
  loginData: LoginData;
  loginDataIsLoading: boolean;
  loginDataErrorMsg: string | null;
  sendOtpData: any;
  sendOtpDataIsLoading: boolean;
  sendOtpDataErrorMsg: string | null;
  getCityData: any[];
  getCityDataIsLoading: boolean;
  getCityDataErrorMsg: string | null;
  verifyEmailOrMobileData: any;
  verifyEmailOrMobileDataIsLoading: boolean;
  verifyEmailOrMobileDataErrorMsg: string | null;
  signUpData: any;
  signUpDataIsLoading: boolean;
  signUpDataErrorMsg: string | null;
  switchAccountData: any;
  switchAccountDataIsLoading: boolean;
  switchAccountDataErrorMsg: string | null;
  meData: any;
  meDataIsLoading: boolean;
  meDataErrorMsg: string | null;
  customerInfoData: any;
  customerInfoDataIsLoading: boolean;
  customerInfoDataErrorMsg: string | null;
}

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    //DeviceToken-----------------------------------
    DeviceToken: '',
    globalError: {},
    customerCallModal: false,

    loginData: {} as LoginData,
    loginDataIsLoading: false,
    loginDataErrorMsg: null,

    // Login Send OTP--------
    sendOtpData: {},
    sendOtpDataIsLoading: false,
    sendOtpDataErrorMsg: null,

    // City--------
    getCityData: [],
    getCityDataIsLoading: false,
    getCityDataErrorMsg: null,

    // verify email
    verifyEmailOrMobileData: {},
    verifyEmailOrMobileDataIsLoading: false,
    verifyEmailOrMobileDataErrorMsg: null,

    signUpData: {},
    signUpDataIsLoading: false,
    signUpDataErrorMsg: null,

    switchAccountData: {},
    switchAccountDataIsLoading: false,
    switchAccountDataErrorMsg: null,

    meData: {},

    customerInfoData: {},  //me data
    customerInfoDataIsLoading: false,
    customerInfoDataErrorMsg: null
  },
  reducers: {
    //DeviceToken-------------------------------------
    DeviceTokenReq: (state, action) => ({
      ...state,
      DeviceTokenData: action.payload,
    }),

    // Global Error
    setGlobalErrorMessage: (state, action) => ({
      ...state,
      globalError: action.payload,
    }),

    clearGlobalErrorMessage: state => ({
      ...state,
      globalError: {},
    }),

    // Login--------------------
    loginReq: (state, action) => { },
    loginSuccess: (state, action) => ({
      ...state,
      loginData: action.payload,
      loginDataIsLoading: false,
      loginDataErrorMsg: null
    }),
    loginFailure: (state, action) => ({
      ...state,
      loginDataIsLoading: false,
      loginDataErrorMsg: action.payload,
    }),
    loginLoading: (state) => ({
      ...state,
      loginDataIsLoading: true,
      loginDataErrorMsg: null,
    }),
    loginClear: (state) => ({
      ...state,
      loginData: {},
      loginDataIsLoading: false,
      loginDataErrorMsg: null,
    }),

    // Send OTP--------------------
    sendOtpReq: (state, action) => { },
    sendOtpSuccess: (state, action) => ({
      ...state,
      sendOtpData: action.payload,
      sendOtpDataIsLoading: false,
      sendOtpDataErrorMsg: null
    }),
    sendOtpFailure: (state, action) => ({
      ...state,
      sendOtpDataIsLoading: false,
      sendOtpDataErrorMsg: action.payload,
    }),
    sendOtpLoading: (state) => ({
      ...state,
      sendOtpDataIsLoading: true,
      sendOtpDataErrorMsg: null,
    }),
    sendOtpClear: (state) => ({
      ...state,
      sendOtpData: {},
      sendOtpDataIsLoading: false,
      sendOtpDataErrorMsg: null,
    }),

    // City--------------------
    getCityDataReq: (state, action) => { },
    getCityDataSuccess: (state, action) => ({
      ...state,
      getCityData: action.payload,
      getCityDataIsLoading: false,
      getCityDataErrorMsg: null
    }),
    getCityDataFailure: (state, action) => ({
      ...state,
      getCityDataIsLoading: false,
      getCityDataErrorMsg: action.payload,
    }),
    getCityDataLoading: (state) => ({
      ...state,
      getCityDataIsLoading: true,
      getCityDataErrorMsg: null,
    }),
    getCityDataClear: (state) => ({
      ...state,
      getCityData: [],
      getCityDataIsLoading: false,
      getCityDataErrorMsg: null,
    }),

    // Verify EMail or Mobile--------------------
    verifyEmailOrMobileReq: (state, action) => { },
    verifyEmailOrMobileSuccess: (state, action) => ({
      ...state,
      verifyEmailOrMobileData: action.payload,
      verifyEmailOrMobileDataIsLoading: false,
      verifyEmailOrMobileDataErrorMsg: null
    }),
    verifyEmailOrMobileFailure: (state, action) => ({
      ...state,
      verifyEmailOrMobileDataIsLoading: false,
      verifyEmailOrMobileDataErrorMsg: action.payload,
    }),
    verifyEmailOrMobileLoading: (state) => ({
      ...state,
      verifyEmailOrMobileDataIsLoading: true,
      verifyEmailOrMobileDataErrorMsg: null,
    }),
    verifyEmailOrMobileClear: (state) => ({
      ...state,
      verifyEmailOrMobileData: {},
      verifyEmailOrMobileDataIsLoading: false,
      verifyEmailOrMobileDataErrorMsg: null,
    }),

    // SingUp Or Register------------------
    signUpReq: (state, action) => { },
    signUpSuccess: (state, action) => ({
      ...state,
      signUpData: action.payload,
      signUpDataIsLoading: false,
      signUpDataErrorMsg: null
    }),
    signUpFailure: (state, action) => ({
      ...state,
      signUpDataIsLoading: false,
      signUpDataErrorMsg: action.payload,
    }),
    signUpLoading: (state) => ({
      ...state,
      signUpDataIsLoading: true,
      signUpDataErrorMsg: null,
    }),
    signUpClear: (state) => ({
      ...state,
      signUpData: {},
      signUpDataIsLoading: false,
      signUpDataErrorMsg: null,
    }),

    switchAccountReq: (state, action) => { },
    switchAccountSuccess: (state, action) => ({
      ...state,
      switchAccountData: action.payload,
      switchAccountDataIsLoading: false,
      switchAccountDataErrorMsg: null
    }),
    switchAccountFailure: (state, action) => ({
      ...state,
      switchAccountDataIsLoading: false,
      switchAccountDataErrorMsg: action.payload,
    }),
    switchAccountLoading: (state) => ({
      ...state,
      switchAccountDataIsLoading: true,
      switchAccountDataErrorMsg: null,
    }),
    switchAccountClear: (state) => ({
      ...state,
      switchAccountData: {},
      switchAccountDataIsLoading: false,
      switchAccountDataErrorMsg: null,
    }),

    customerCallModalFun: (state, action) => ({
      ...state,
      customerCallModal: action.payload,
    }),
    customerCallModalFunClear: (state) => ({
      ...state,
      customerCallModal: false,
    }),

    meDataSuccess: (state, action) => ({
      ...state,
      meData: action.payload,
    }),

    customerInfoReq: (state, action) => { },
    customerInfoSuccess: (state, action) => ({
      ...state,
      customerInfoData: action.payload,
      customerInfoDataIsLoading: false,
      customerInfoDataErrorMsg: null
    }),
    customerInfoFailure: (state, action) => ({
      ...state,
      customerInfoDataIsLoading: false,
      customerInfoDataErrorMsg: action.payload,
    }),
    customerInfoLoading: (state) => ({
      ...state,
      customerInfoDataIsLoading: true,
      customerInfoDataErrorMsg: null,
    }),
    customerInfoClear: (state) => ({
      ...state,
      customerInfoData: {},
      customerInfoDataIsLoading: false,
      customerInfoDataErrorMsg: null,
    }),
  },
});

export const {
  //DeviceToken------------------------------
  DeviceTokenReq,

  // Global error
  setGlobalErrorMessage,
  clearGlobalErrorMessage,

  // Login ------
  loginReq,
  loginLoading,
  loginSuccess,
  loginFailure,
  loginClear,

  // send OTP 
  sendOtpReq,
  sendOtpLoading,
  sendOtpSuccess,
  sendOtpFailure,
  sendOtpClear,

  // Get City Data
  getCityDataReq,
  getCityDataLoading,
  getCityDataSuccess,
  getCityDataFailure,
  getCityDataClear,

  // Verify Email or Mobile
  verifyEmailOrMobileClear,
  verifyEmailOrMobileFailure,
  verifyEmailOrMobileLoading,
  verifyEmailOrMobileReq,
  verifyEmailOrMobileSuccess,

  // SignUp Req------
  signUpClear,
  signUpFailure,
  signUpLoading,
  signUpReq,
  signUpSuccess,

  switchAccountClear,
  switchAccountFailure,
  switchAccountLoading,
  switchAccountReq,
  switchAccountSuccess,

  customerCallModalFun,
  customerCallModalFunClear,

  meDataSuccess,

  customerInfoClear,
  customerInfoFailure,
  customerInfoLoading,
  customerInfoReq,
  customerInfoSuccess
} = authSlice.actions;

export default authSlice.reducer;
